export const translations = {
  // Menu items
  myActivities: 'Mis Actividades',
  taskControl: 'Nuevas Demandas',
  minhasNotas: 'Nuevas Demandas',
  timeUsage: 'Mi Uso del Tiempo',
  chat: 'Chat',
  projects: 'Proyectos',
  nankinInsights: 'Insights de Nankin',
  productSpec: 'Especificación de Productos',
  gettingStarted: 'Primeros Pasos',
  helpAndSupport: 'Ayuda y Soporte',
  
  // Activities submenu
  strategic: 'Visión Estratégica',
  monitoring: 'Monitoreo',
  activities: 'Actividades',
  'activities-2': 'Actividades 2',
  calendar: 'Calendario',
  
  // Tasks submenu
  inbox: 'Bandeja de entrada',
  today: 'Hoy',
  upcoming: 'Próximos días',
  completed: 'Completado',
  
  // Time submenu
  tracker: 'Rastreador',
  projectPlan: 'Plan de Proyecto',
  plannedVsActual: 'Planificado vs Real',
  reports: 'Informes',
  tags: 'Etiquetas',

  // Finance submenu
  reconciliation: 'Conciliación',
  'financial-movements': 'Movimientos',
  'financial-dashboard': 'Panel Financiero',
  'financial-projects': 'Proyectos',
  'financial-registers': 'Registros',
  'financial-calendar': 'Calendario',
  'financial-reports': 'Informes',

  // Common actions
  add: 'Agregar',
  edit: 'Editar',
  delete: 'Eliminar',
  cancel: 'Cancelar',
  save: 'Guardar',
  close: 'Cerrar',
  
  // Settings
  settings: 'Configuración',
  language: 'Idioma',
  selectLanguage: 'Seleccionar idioma de la interfaz',
  languageChanged: 'El idioma seleccionado se aplicará en toda la interfaz del sistema'
} as const;